const YOUTUBE_READY_FLAG = '__trillboardsYouTubeApiReady';

function resetYouTubePlayerReady(iframe) {
  if (!iframe) return;
  try {
    iframe[YOUTUBE_READY_FLAG] = false;
  } catch (_) {}
}

function isYouTubePlayerReady(iframe) {
  return Boolean(iframe && iframe[YOUTUBE_READY_FLAG] === true);
}

function isYouTubePlayerReadyMessage(data) {
  return Boolean(data && (
    data.event === 'initialDelivery'
    || data.event === 'onReady'
    || data.event === 'infoDelivery'
  ));
}

function markYouTubePlayerReady(iframe, data) {
  if (!iframe || !isYouTubePlayerReadyMessage(data)) return false;
  var becameReady = !isYouTubePlayerReady(iframe);
  try {
    iframe[YOUTUBE_READY_FLAG] = true;
  } catch (_) {
    return false;
  }
  return becameReady;
}

function postYouTubeListening(iframe, id) {
  if (!iframe || !iframe.contentWindow) return false;
  try {
    iframe.contentWindow.postMessage(JSON.stringify({
      event: 'listening',
      id: id || 'trillboards'
    }), '*');
    return true;
  } catch (_) {
    return false;
  }
}

function postYouTubePlayerCommand(iframe, func, args, id) {
  if (!isYouTubePlayerReady(iframe) || !iframe.contentWindow) return false;
  try {
    var payload = {
      event: 'command',
      func: func,
      args: Array.isArray(args) ? args : []
    };
    if (id) payload.id = id;
    iframe.contentWindow.postMessage(JSON.stringify(payload), '*');
    return true;
  } catch (_) {
    return false;
  }
}

var YouTubePlayerBridge = {
  resetYouTubePlayerReady: resetYouTubePlayerReady,
  isYouTubePlayerReady: isYouTubePlayerReady,
  isYouTubePlayerReadyMessage: isYouTubePlayerReadyMessage,
  markYouTubePlayerReady: markYouTubePlayerReady,
  postYouTubeListening: postYouTubeListening,
  postYouTubePlayerCommand: postYouTubePlayerCommand
};

if (typeof window !== 'undefined') {
  window.TrillboardsYouTubePlayerBridge = YouTubePlayerBridge;
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = YouTubePlayerBridge;
}
